var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.105,
    height: 39.376,
    viewBox: "0 0 51.105 39.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2eafbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ac3bb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-credit-card",
    "data-name": "Icon awesome-credit-card",
    d: "M0,37.407a4.24,4.24,0,0,0,4.259,4.219H46.846a4.24,4.24,0,0,0,4.259-4.219V21.938H0Zm17.035-5.977A1.063,1.063,0,0,1,18.1,30.376H30.166a1.063,1.063,0,0,1,1.065,1.055v3.516A1.063,1.063,0,0,1,30.166,36H18.1a1.063,1.063,0,0,1-1.065-1.055Zm-11.357,0a1.063,1.063,0,0,1,1.065-1.055h6.388A1.063,1.063,0,0,1,14.2,31.431v3.516A1.063,1.063,0,0,1,13.131,36H6.743a1.063,1.063,0,0,1-1.065-1.055ZM51.105,6.469v4.219H0V6.469A4.24,4.24,0,0,1,4.259,2.25H46.846A4.24,4.24,0,0,1,51.105,6.469Z",
    transform: "translate(0 -2.25)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.d819098d9c42dcefda1f4ae568b713cd.svg";
export { ForwardRef as ReactComponent };